import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { getClientDomain, getToken, round, formatter, translate, formatDatePicker, verifyHideCountryItems, getPropertyPackagesStatus, getPackageTypeInfo, getPackageDetailStatusLabel, handlerGetClasificacion, copyToClipboard } from '../../../../utils/Common';
import { useForm } from "react-hook-form";
import AuthContext from '../../../../contexts/auth';
import ModalContext from '../../../../contexts/modal';
import PlatformList from '../../../../components/PlatformList';
import ContentCard from '../../../../components/layout/ContentCard/ContentCard';
import Button from '../../../../components/common/Button/Button';
import Input from '../../../../components/common/Input/Input';
import { FaEye, FaEyeSlash, FaEnvelope, FaChevronDown, FaChevronUp, FaKey, FaTruck } from 'react-icons/fa';
import { FiPackage, FiUser } from 'react-icons/fi';
import { FaBox, FaMoneyBillAlt, FaTruckLoading, FaCalendarAlt, FaTicketAlt, FaLock, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import { PiLockersFill } from 'react-icons/pi';
import ModalContent from "../../../../components/ModalContent";
import { BsPeopleFill } from 'react-icons/bs';
import ClientsSearchList from '../../../../components/ClientsSearchList';
import BtnSync from '../../../../components/BtnSync';
import Spinner from "../../../../components/Spinner";
import { usePackages } from '../../../../hooks/usePackages';
import { verifyAccessViewPermissions } from '../../../../config/permissions';
import { ToastContainer, useToast } from '../../../../components/common/Toast';
import styles from './PackageDetail.module.css';

// formulario con los detalles del paquete
const PackageInfo = (props) => {
    const userContext = useContext(AuthContext);
    const modalContext = useContext(ModalContext);
    const { saveTrackingViewPin } = usePackages();
    const { toasts, showError, removeToast } = useToast();
    const userRole = JSON.parse(sessionStorage.getItem("user")).roleId;
    const permissionsPath = '/dashboard/packages/tracking';
    const canReadPickupCode = verifyAccessViewPermissions(['read-pickup-code'], { path: permissionsPath });
    const { register, errors, handleSubmit, setError, clearErrors, reset } = useForm();
    const [showPin, setShowPin] = useState(false);
    const [isLoadingPin, setIsLoadingPin] = useState(false);
    const [isCustomItbms, setIsCustomItbms] = useState(false);
    const [showCostBreakdown, setShowCostBreakdown] = useState(false);
    const [reservationIdCopied, setReservationIdCopied] = useState(false);
    const [dropOffCodeCopied, setDropOffCodeCopied] = useState(false);

    // enviar update al servidor
    const sendUpdatePackageInfo = async (data) => {
        try {
            let dataToSend = {
                courier: props.selectedPackage.Courier,
                estatus: props.selectedPackage.Estatus,
                numeroPaquete: props.selectedPackage.Nro_Id,
                numeroTracking: props.selectedPackage.NumeroTracking,
                idUsuario: props.selectedPackage.IdUsuario,
                idPlataforma: props.selectedPackage.IdPlataforma,
                idPlataformaDet: props.selectedPackage.IdPlataformaDet,
                email: props.selectedPackage.Email,
                descripcion: props.selectedPackage.Descripcion,
                clasificacion: props.selectedPackage.Clasificacion,
                alto: props.selectedPackage.Alto,
                largo: props.selectedPackage.Largo,
                ancho: props.selectedPackage.Ancho,
                peso: props.selectedPackage.PesoLibras,
                costoProv: props.selectedPackage.CostoProv,
                precioBase: props.selectedPackage.PrecioBase,
                cargoAduana: props.selectedPackage.CargoAduana,
                otrosCargos: props.selectedPackage.OtrosCargos,
                itbms: props.selectedPackage.Itbms,
                precio: props.selectedPackage.Precio,
                dateExpiration: props.selectedPackage.FechaExpiracion,
                packageId: props.selectedPackage.IdPaquete,
                actionSelect: props.optionSelected,
                idCliente: props.selectedPackage.IdCliente
            }

            if (props.optionSelected === "ChangeInfo") {
                dataToSend.email = data.email;
                dataToSend.descripcion = data.descripcion;
                dataToSend.clasificacion = valueClasificacion;
                dataToSend.alto = round(Number(data.alto) * 2.54, 2);
                dataToSend.largo = round(Number(data.largo) * 2.54, 2);
                dataToSend.ancho = round(Number(data.ancho) * 2.54, 2);
                dataToSend.peso = Number(data.peso);
                dataToSend.precio = round(Number(data.precio), 2);
                if (userContext.user?.IsAdmin) {
                    dataToSend.costoProv = round(Number(data.costoProv), 2);
                    dataToSend.precioBase = round(Number(data.precioBase), 2);
                    dataToSend.cargoAduana = round(Number(data.cargoAduana), 2);
                    dataToSend.otrosCargos = round(Number(data.otrosCargos), 2);
                    dataToSend.precio = round(Number(precio), 2);
                    dataToSend.itbms = round(Number(itbms), 2);
                }
            }
            else if (props.optionSelected === "ChangePlatform") {
                dataToSend.idPlataforma = data.plataforma;
                dataToSend.idPlataformaDet = data.idPlataformaDet;
                dataToSend.clasificacion = handlerGetClasificacion(dataToSend.clasificacion);
            }
            else if (props.optionSelected === "ChangeClient") {
                if (!selectedClient) {
                    setError('buscarCliente', {
                        type: '',
                        message: translate("dashboard.packages.loadpackage.searchClient.inputData")
                    });
                    return;
                }

                if (selectedClient === dataToSend.idCliente) {
                    setError('buscarCliente', {
                        type: '',
                        message: translate("global.messageClientSelected")
                    });
                    return;
                }

                dataToSend.idCliente = selectedClient;

            } else
                if (props.optionSelected === "ChangeDateExpiration") {
                    dataToSend.dateExpiration = data.dateExpiration;
                }

            props.onClickPanelOption("");
            const response = await fetch(`${getClientDomain(2)}/dashboard/packages/update${props.optionSelected === "ChangeDateExpiration" ? "/dateExpiration" : ""}`, {
                method: 'PATCH',
                connection: 'keep-alive',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(dataToSend)
            });
            const result = await response.json();

            if (props.optionSelected === "ChangeClient") {
                props.handleOpenModalChangeClient(); // cerrar modal de ChangeClient    
            }

            if (result.code === 200) {
                if (result.message === 'PACKAGE_UPDATED') {
                    props.getInfoPaquete(props.selectedPackage);
                    modalContext.confirm(translate("global.alerts.successTransact"),
                        <span>{translate("dashboard.packages.details.info.PACKAGE_UPDATED")}</span>,
                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={() => modalContext.setIsOpenModal(false)}>{translate("global.accept")}</button>,
                        true);
                }
                else {
                    modalContext.confirm(translate("global.alerts.ops"),
                        <span>{translate("dashboard.packages.details.info.PACKAGE_UPDATED_ERROR")}</span>,
                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={() => modalContext.setIsOpenModal(false)}>{translate("global.accept")}</button>,
                        true);
                    props.onClickPanelOption("");
                }
            }
            else {
                modalContext.confirm(translate("global.alerts.ops"),
                    <span>{translate("dashboard.packages.details.info.PACKAGE_UPDATED_ERROR")}</span>,
                    <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={() => modalContext.setIsOpenModal(false)}>{translate("global.accept")}</button>,
                    true);
                props.onClickPanelOption("");
            }
        } catch (err) {
            console.log(err);
        }
    }


    // si cancelo la operacion, volver a los valores iniciales
    const cancelOption = () => {
        setCostoProv(props.selectedPackage.CostoProv);
        setPrecioBase(props.selectedPackage.PrecioBase);
        setCargoAduana(props.selectedPackage.CargoAduana);
        setOtrosCargos(props.selectedPackage.OtrosCargos);
        setItbms(props.selectedPackage.Itbms);
        setSelectedClient(null);
        clearErrors();
        props.onClickPanelOption("");
    }

    let clasificacionList = ['P', 'M', 'G'];
    const [costoProv, setCostoProv] = useState((userContext.user?.IsAdmin && props.selectedPackage.CostoProv) ? Number(props.selectedPackage.CostoProv) : 0);
    const [precioBase, setPrecioBase] = useState(userContext.user?.IsAdmin ? Number(props.selectedPackage.PrecioBase) : Number(props.selectedPackage.CostoProv));
    const [cargoAduana, setCargoAduana] = useState((userContext.user?.IsAdmin && props.selectedPackage.CargoAduana) ? Number(props.selectedPackage.CargoAduana) : 0);
    const [otrosCargos, setOtrosCargos] = useState((userContext.user?.IsAdmin && props.selectedPackage.OtrosCargos) ? Number(props.selectedPackage.OtrosCargos) : 0);
    const [itbms, setItbms] = useState(props.selectedPackage.Itbms ? Number(props.selectedPackage.Itbms) : 0);


    useEffect(() => {
        if (userContext.user?.IsAdmin && isCustomItbms) {
            const subtotal = Number(precioBase) + Number(cargoAduana) + Number(otrosCargos);
            const newItbms = round(subtotal * 0.07, 2);
            setItbms(newItbms);
            setPrecio(round(subtotal + newItbms, 2));
        }
    }, [precioBase, cargoAduana, otrosCargos]);

    const [precio, setPrecio] = useState(props.selectedPackage.Precio);
    useEffect(() => {
        let total = Number(precioBase) + Number(cargoAduana) + Number(otrosCargos) + Number(itbms);
        setPrecio(round(total, 2));
    }, [precioBase, cargoAduana, otrosCargos, itbms]);

    // variables usadas para la busqueda del cliente

    const [selectedClient, setSelectedClient] = useState(null);
    const [valueClasificacion, setValueClasificacion] = useState(props.selectedPackage?.Clasificacion || "");

    const renderModalChangeClient = (
        <>
            <ModalContent
                isOpenModal={props.isOpenModalChangeClient}
                onHide={props.handleOpenModalChangeClient}
                title={translate("global.changeClient")}
                body={<>
                    <div style={{ textAlign: "left" }}>
                        <span>{translate("global.currentClient")}:</span>
                        <input className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed text-sm" disabled value={props.selectedPackage?.IdCliente + " - " + props.selectedPackage?.Cliente} />
                    </div>
                    <div className='pt-3' style={{ textAlign: "left" }}>
                        <span>{translate("global.newClient")}:</span>
                        {/* <SearchClient
    idUsuarioSelected={props.selectedPackage?.IdUsuario}
    errors={errors}
    setError={setError}
    clearErrors={clearErrors}
    register={register}
    idTipoCliente={ props.selectedPackage?.IdTipoUsuario > 1 ? 7 : 1 }
    buscarCliente={buscarCliente}
    handleBuscarCliente={setBuscarCliente}
    selectClientes={selectClientes}
    handleSelectClientes={setSelectClientes}
    handleSelectedClient={handleSelectedClient}
    />  */}

                        <ClientsSearchList
                            idUsuarioSelected={props.selectedPackage?.IdUsuario}
                            errors={errors}
                            setError={setError}
                            clearErrors={clearErrors}
                            register={register}
                            idTipoCliente={props.selectedPackage?.IdTipoUsuario > 1 ? 7 : 1}
                            setSelectOption={setSelectedClient}
                            autoSelectClient
                        />
                    </div>
                </>}
                footer={<>
                    <Button variant="ghostOutline" onClick={props.handleOpenModalChangeClient}>
                        {translate("global.close")}
                    </Button>
                    <Button variant="primary" type="button" onClick={() => { handleSubmit(sendUpdatePackageInfo)(); }}>
                        {translate("global.save")}
                    </Button>
                </>}
            />
        </>
    )

    useEffect(() => {
        reset();
        setSelectedClient(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.optionSelected]);

    const statusInfoForItem = props.selectedPackage?.IdEstatus != null ? getPropertyPackagesStatus(props.selectedPackage.IdEstatus) : null;
    const typeInfoForItem = props.selectedPackage ? getPackageTypeInfo(props.selectedPackage) : null;

    const handleViewPin = async () => {
        const abortController = new AbortController();
        if (!canReadPickupCode) return;

        if (!showPin) {
            setIsLoadingPin(true);
            try {
                const result = await saveTrackingViewPin(abortController.signal, {
                    packageId: props.selectedPackage?.IdPaquete,
                    clientId: props.selectedPackage?.IdCliente,
                });
                if (!result?.ok) {
                    const specificKey = result?.message
                        ? `dashboard.packages.details.viewPin.${result.message}`
                        : null;
                    const specific =
                        specificKey && translate(specificKey) !== specificKey
                            ? translate(specificKey)
                            : null;
                    showError(specific || translate('dashboard.packages.details.error.pickupPin'));
                    return;
                }
                setShowPin(true);
            } catch {
                showError(translate('dashboard.packages.details.error.pickupPin'));
            } finally {
                setIsLoadingPin(false);
            }
        } else {
            setShowPin(false);
        }
    }

    return (
        <>
            <ToastContainer toasts={toasts} removeToast={removeToast} />
            <form className={`${styles.overviewContainer} package-info`} onSubmit={handleSubmit(sendUpdatePackageInfo)} style={{ margin: 0, padding: 0 }}>
                <div className={styles.overviewGrid}>
                    {/* Resumen único: Package Information + Description + Medidas */}
                    <div className={styles.overviewGridCol}>
                        <ContentCard title={<div className={styles.cardTitle}><FiPackage size={20} /><span>{translate("dashboard.packages.details.card.summary")}</span></div>} padding="md" className={styles.infoCard}>
                            <div className={styles.infoList}>
                                {/* Provider + Status + Type arriba; luego Identification */}
                                <div className={styles.infoBlock}>
                                    <div className={styles.infoRow3}>
                                        <div className={styles.infoItem}>
                                            <span className={styles.infoLabel}>{translate("global.status")}</span>
                                            <span className={styles.infoValue}>{statusInfoForItem ? (
                                                <span
                                                    className={styles.statusPill}
                                                    style={{
                                                        color: statusInfoForItem.color || '#111827',
                                                        backgroundColor: 'transparent',
                                                        borderColor: statusInfoForItem.color || 'currentColor',
                                                    }}
                                                >
                                                    {statusInfoForItem.icon && <span className={styles.infoIcon}>{statusInfoForItem.icon}</span>}
                                                    <span>{getPackageDetailStatusLabel(props.selectedPackage?.IdEstatus, props.selectedPackage?.IdTipoPaquete)}</span>
                                                </span>
                                            ) : ''}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <span className={styles.infoLabel}>{translate("global.typeOfPackage")}</span>
                                            <span className={styles.infoValue}>{typeInfoForItem ? (
                                                <span
                                                    className={styles.statusPill}
                                                    style={{
                                                        color: typeInfoForItem.color || '#111827',
                                                        backgroundColor: typeInfoForItem.bg || 'rgba(0,0,0,0.03)',
                                                        borderColor: 'transparent',
                                                    }}
                                                >
                                                    {typeInfoForItem.icon && <span className={styles.infoIcon}>{typeInfoForItem.icon}</span>}
                                                    <span>{typeInfoForItem.text ? translate(typeInfoForItem.text) : ''}</span>
                                                </span>
                                            ) : ''}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <span className={styles.infoLabel}>{translate("global.provider")}</span>
                                            <span className={styles.infoValue}>
                                                <span className={styles.providerInline}>
                                                    <FaTruck size={14} className={styles.providerIcon} />
                                                    <span className={styles.providerName}>{props.selectedPackage?.Proveedor ?? '—'}</span>
                                                    <span className={styles.providerId}>ID {props.selectedPackage?.IdUsuario ?? '—'}</span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className={styles.infoRow3}>
                                        <div className={styles.infoItem}>
                                            <span className={styles.infoLabel}><FaKey size={12} className={styles.identRowIcon} /> ID Boxit</span>
                                            <span className={styles.infoValue}>{props.selectedPackage?.IdPaquete ?? ''}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <span className={styles.infoLabel}><FaBox size={12} className={styles.identRowIcon} /> {translate("global.numPackage")}</span>
                                            <span className={styles.infoValue}>{props.selectedPackage?.Nro_Id ?? ''}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <span className={styles.infoLabel}><FaTruckLoading size={12} className={styles.identRowIcon} /> {translate("dashboard.packages.details.numTracking")}</span>
                                            <span className={styles.infoValue}>{props.selectedPackage?.NumeroTracking ?? ''}</span>
                                        </div>
                                        {!verifyHideCountryItems(["us"]) && (
                                            <div className={`${styles.infoItem} ${styles.infoItemFullWidth}`}>
                                                <span className={styles.infoLabel}><FaTicketAlt size={12} className={styles.identRowIcon} /> {translate("global.reservationId")}</span>
                                                <div className={styles.reservationIdValueWrap}>
                                                    <span className={styles.reservationIdValue} title={props.selectedPackage?.ReservationIdGl ?? ''}>{props.selectedPackage?.ReservationIdGl ?? '—'}</span>
                                                    <button type="button" onClick={() => { copyToClipboard(props.selectedPackage?.ReservationIdGl || ''); setReservationIdCopied(true); setTimeout(() => setReservationIdCopied(false), 2000); }} className={styles.copyButton} aria-label={translate("global.copy") || "Copiar"}>
                                                        <FaCopy size={14} />
                                                    </button>
                                                    {reservationIdCopied && <span className={styles.copyFeedback}>{translate("global.copied")}</span>}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Drop Off: Code, Courier, Label (cuando hay datos de entrega) */}
                                {(props.selectedPackage?.Code || props.selectedPackage?.CourierName || props.selectedPackage?.LabelURL) && (
                                    <div className={styles.infoBlock}>
                                        <span className={styles.infoBlockTitle}>{translate("global.status.typePackage.dropoff")}</span>
                                        <div className={styles.infoRow3}>
                                            {props.selectedPackage?.Code && (
                                                <div className={styles.infoItem}>
                                                    <span className={styles.infoLabel}>{translate("global.code")}</span>
                                                    <div className={styles.reservationIdValueWrap}>
                                                        <span className={styles.reservationIdValue} title={props.selectedPackage?.Code}>{props.selectedPackage?.Code}</span>
                                                        <button type="button" onClick={() => { copyToClipboard(props.selectedPackage?.Code || ''); setDropOffCodeCopied(true); setTimeout(() => setDropOffCodeCopied(false), 2000); }} className={styles.copyButton} aria-label={translate("global.copy") || "Copiar"}>
                                                            <FaCopy size={14} />
                                                        </button>
                                                        {dropOffCodeCopied && <span className={styles.copyFeedback}>{translate("global.copied")}</span>}
                                                    </div>
                                                </div>
                                            )}
                                            {props.selectedPackage?.CourierName && (
                                                <div className={styles.infoItem}>
                                                    <span className={styles.infoLabel}>{translate("global.courierName")}</span>
                                                    <span className={styles.infoValue}>{props.selectedPackage?.CourierName}</span>
                                                </div>
                                            )}
                                            {props.selectedPackage?.LabelURL && (
                                                <div className={styles.infoItem}>
                                                    <span className={styles.infoLabel}>{translate("global.labelUrl")}</span>
                                                    <span className={styles.infoValue}>
                                                        <a href={props.selectedPackage.LabelURL} target="_blank" rel="noreferrer" title={translate("global.viewLink")} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                            <FaExternalLinkAlt size={13} />
                                                            {translate("global.viewLink")}
                                                        </a>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {/* Medidas: layout compacto en grid */}
                                <div className={styles.infoBlock}>
                                    <span className={styles.infoBlockTitle}>{translate("global.dimensions")}</span>
                                    <div className={styles.dimensionsGrid}>
                                        <div className={styles.dimensionsItem}>
                                            <span className={styles.dimensionsLabel}>{translate("global.size")}</span>
                                            <select className={styles.inputLikeSelect} defaultValue={props.selectedPackage?.Clasificacion} name="clasificacion" ref={register} onChange={e => setValueClasificacion(e.target.value)} disabled={(props.selectedPackage?.IdEstatus === 3) || (props.optionSelected !== "ChangeInfo")} id="selectClasificacion">
                                                <option value={props.selectedPackage?.Clasificacion}>{handlerGetClasificacion(props.selectedPackage?.Clasificacion)}</option>
                                                {clasificacionList.map((c, i) => c !== handlerGetClasificacion(props.selectedPackage?.Clasificacion) && <option key={i} value={clasificacionList[i]}>{clasificacionList[i]}</option>)}
                                            </select>
                                        </div>
                                        <div className={styles.dimensionsItem}>
                                            <span className={styles.dimensionsLabel}>{translate("global.high")} (inch)</span>
                                            {props.optionSelected === "ChangeInfo" ? <Input type="number" name="alto" ref={register} defaultValue={props.selectedPackage?.Alto !== 0 ? round(Number(props.selectedPackage.Alto) / 2.54, 2) : 0} fullWidth /> : <span className={styles.infoValue}>{props.selectedPackage?.Alto !== 0 ? round(Number(props.selectedPackage.Alto) / 2.54, 2) : '—'}</span>}
                                        </div>
                                        <div className={styles.dimensionsItem}>
                                            <span className={styles.dimensionsLabel}>{translate("global.long")} (inch)</span>
                                            {props.optionSelected === "ChangeInfo" ? <Input type="number" name="largo" ref={register} defaultValue={props.selectedPackage?.Largo !== 0 ? round(Number(props.selectedPackage.Largo) / 2.54, 2) : 0} fullWidth /> : <span className={styles.infoValue}>{props.selectedPackage?.Largo !== 0 ? round(Number(props.selectedPackage.Largo) / 2.54, 2) : '—'}</span>}
                                        </div>
                                        <div className={styles.dimensionsItem}>
                                            <span className={styles.dimensionsLabel}>{translate("global.width")} (inch)</span>
                                            {props.optionSelected === "ChangeInfo" ? <Input type="number" name="ancho" ref={register} defaultValue={props.selectedPackage?.Ancho !== 0 ? round(Number(props.selectedPackage.Ancho) / 2.54, 2) : 0} fullWidth /> : <span className={styles.infoValue}>{props.selectedPackage?.Ancho !== 0 ? round(Number(props.selectedPackage.Ancho) / 2.54, 2) : '—'}</span>}
                                        </div>
                                        <div className={styles.dimensionsItem}>
                                            <span className={styles.dimensionsLabel}>{translate("global.weight")} (lb)</span>
                                            {props.optionSelected === "ChangeInfo" ? (
                                                <Input type="number" name="peso" ref={register} defaultValue={props.selectedPackage?.PesoLibras} fullWidth />
                                            ) : (
                                                <span className={styles.infoValue}>{props.selectedPackage?.PesoLibras ?? '—'}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {/* Descripción: después de Medidas */}
                                <div className={styles.infoBlock}>
                                    <span className={styles.infoBlockTitle}>{translate("global.description")}</span>
                                    <div className={styles.descriptionContent}>
                                        {props.optionSelected === "ChangeInfo" ? (
                                            <textarea rows={3} defaultValue={props.selectedPackage?.Descripcion ?? ''} name="descripcion" ref={register} className={styles.inputLikeTextarea} id="inputDescripcion" />
                                        ) : (
                                            <span className={styles.infoValue}>{props.selectedPackage?.Descripcion || '—'}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </ContentCard>

                        {/* Costs: card comentado — cambiar false a true para volver a mostrarlo */}
                        {false && (
                            <ContentCard title={<div className={styles.cardTitle}><FaMoneyBillAlt size={20} /><span>{translate("dashboard.packages.details.costs") || "Costs"}</span></div>} padding="md" className={`${styles.infoCard} ${styles.compactCard}`}>
                                <div className={styles.compactCardBody}>
                                    <div className={styles.costsTotalRow}>
                                        <span className={styles.costsTotalLabel}>{translate("global.totalAmount")}</span>
                                        <span className={styles.costsTotalValue}>B/. {precio ? precio.toFixed(2) : (props.selectedPackage?.Precio ? Number(props.selectedPackage.Precio).toFixed(2) : '0.00')}</span>
                                    </div>
                                    <button type="button" className={styles.viewBreakdownBtn} onClick={() => setShowCostBreakdown(!showCostBreakdown)} aria-expanded={showCostBreakdown}>
                                        {showCostBreakdown ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                                        <span>{translate("dashboard.packages.details.viewBreakdown") || "View breakdown"}</span>
                                    </button>
                                    {showCostBreakdown && (
                                        <div className={styles.totalAmountBody}>
                                            <table className={`w-full border-collapse text-left ${styles.tableOverCard} ${styles.tableAmountRight}`} style={{ width: '100%' }}>
                                                <tbody className="text-sm">
                                                    {userContext.user?.IsAdmin ?
                                                        <>
                                                            <tr className="border-bottom">
                                                                <td className="p-1 w-2/12">{translate("global.cost") + translate("global.provider")} <span className="text-xs">(B/)</span>:</td>
                                                                <td className="ml-3 p-1 w-1/12">
                                                                    {props.optionSelected !== "ChangeInfo" ?
                                                                        <span className="font-semibold text-right" >
                                                                            {props.selectedPackage?.CostoProv ? Number(props.selectedPackage?.CostoProv).toFixed(2) : '0.00'}
                                                                        </span>
                                                                        :
                                                                        <input type="number"
                                                                            step=".01"
                                                                            value={costoProv}
                                                                            onChange={(e) => setCostoProv(e.target.value)}
                                                                            className={`${styles.inputLikeInput} ${styles.inputRight}`}
                                                                            id="inputCostoProv" name="costoProv"
                                                                            ref={register} />
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="p-1 w-2/12">{translate("global.baseCost")} <span className="text-xs">(B/)</span>:</td>
                                                                <td className="ml-3 p-1 w-1/12">
                                                                    {props.optionSelected !== "ChangeInfo" ?
                                                                        <span className="font-semibold text-right" >
                                                                            {props.selectedPackage?.PrecioBase ? Number(props.selectedPackage?.PrecioBase).toFixed(2) : '0.00'}
                                                                        </span>
                                                                        :
                                                                        <input type="number"
                                                                            step=".01"
                                                                            value={precioBase}
                                                                            onChange={(e) => {
                                                                                setPrecioBase(e.target.value);
                                                                                setIsCustomItbms(true);
                                                                            }}
                                                                            className={`${styles.inputLikeInput} ${styles.inputRight}`}
                                                                            id="inputPrecioBase" name="precioBase"
                                                                            ref={register} />
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="p-1 w-2/12">{translate("dashboard.packages.loadpackages.formProvider.customsCharge")}<span className="text-xs">(B/)</span>:</td>
                                                                <td className="ml-3 p-1 w-1/12">
                                                                    {props.optionSelected !== "ChangeInfo" ?
                                                                        <span className="font-semibold text-right" >
                                                                            {props.selectedPackage?.CargoAduana ? Number(props.selectedPackage?.CargoAduana).toFixed(2) : '0.00'}

                                                                        </span>
                                                                        :
                                                                        <input type="number"
                                                                            step=".01"
                                                                            value={cargoAduana}
                                                                            onChange={(e) => {
                                                                                setCargoAduana(e.target.value);
                                                                                setIsCustomItbms(true);
                                                                            }}
                                                                            className={`${styles.inputLikeInput} ${styles.inputRight}`}
                                                                            id="inputCargoAduana" name="cargoAduana"
                                                                            ref={register} />
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="p-1 w-2/12">{translate("dashboard.packages.loadpackages.formProvider.othersCharges")} <span className="text-xs">(B/)</span>:</td>
                                                                <td className="ml-3 p-1 w-1/12">
                                                                    {props.optionSelected !== "ChangeInfo" ?
                                                                        <span className="font-semibold text-right" >
                                                                            {props.selectedPackage?.OtrosCargos ? Number(props.selectedPackage?.OtrosCargos).toFixed(2) : '0.00'}
                                                                        </span>
                                                                        :
                                                                        <input type="number"
                                                                            step=".01"
                                                                            value={otrosCargos}
                                                                            onChange={(e) => {
                                                                                setOtrosCargos(e.target.value);
                                                                                setIsCustomItbms(true);
                                                                            }}
                                                                            className={`${styles.inputLikeInput} ${styles.inputRight}`}
                                                                            id="inputOtrosCargos" name="otrosCargos"
                                                                            ref={register} />
                                                                    }
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td className="p-1 w-2/12">ITBMS <span className="text-xs">(B/)</span>:</td>
                                                                <td className="ml-3 p-1 w-1/12 font-semibold text-right">

                                                                    {props.optionSelected !== "ChangeInfo" ?
                                                                        <span className="font-semibold text-right" >
                                                                            {itbms ? Number(itbms).toFixed(2) : '0.00'}
                                                                        </span>
                                                                        :
                                                                        <input type="number"
                                                                            step=".01"
                                                                            value={itbms}
                                                                            onChange={(e) => setItbms(e.target.value)}
                                                                            className={`${styles.inputLikeInput} ${styles.inputRight}`}
                                                                            id="inputItbms" name="itbms"
                                                                            ref={register} />
                                                                    }
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td className="p-1 w-2/12">{translate("dashboard.packages.loadpackages.formProvider.costTotal")} <span className="text-xs">(B/)</span>:</td>
                                                                <td className="ml-3 p-1 w-1/12 font-semibold text-right">
                                                                    {precio ? precio.toFixed(2) : '0.00'}
                                                                </td>
                                                            </tr>
                                                        </>
                                                        :
                                                        <tr>
                                                            <td className="p-1 w-2/12">{translate("global.totalAmount")}:</td>
                                                            <td className="ml-3 p-1 w-1/12">
                                                                {props.optionSelected !== "ChangeInfo" ?
                                                                    <span className="font-semibold">{formatter.format(props.selectedPackage?.Precio ? props.selectedPackage?.Precio : 0)}</span>
                                                                    :
                                                                    <input type="number"
                                                                        className={`${styles.inputLikeInput} ${styles.inputRight}`}
                                                                        step=".01"
                                                                        defaultValue={props.selectedPackage?.Precio ? Number(props.selectedPackage?.Precio) : 0}
                                                                        name="precio"
                                                                        ref={register} />
                                                                }
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </ContentCard>
                        )}

                    </div>

                    {/* Columna derecha: Client (compacto) + Location (abajo) */}
                    <div className={styles.overviewGridCol}>
                        <ContentCard title={<div className={styles.cardTitle}><FiUser size={20} /><span>{translate("global.client")}</span></div>} padding="md" className={`${styles.infoCard} ${styles.compactCard}`}>
                            <div className={styles.compactCardBody}>
                                <div className={styles.clientCompactContent}>
                                    <div className={styles.clientNameRow}>
                                        <FiUser size={14} className={styles.clientNameIcon} />
                                        <span>{props.selectedPackage?.Cliente ?? '—'}</span>
                                    </div>
                                    {userContext.user?.IdTipoUsuario !== 1 && (
                                        <div className={styles.clientEmailRow}>
                                            <FaEnvelope size={14} className={styles.clientEmailIcon} />
                                            {props.optionSelected === "ChangeInfo" ? (
                                                <Input type="email" name="email" ref={register({ required: true })} defaultValue={props.selectedPackage?.Email ? props.selectedPackage.Email.toLowerCase() : ''} fullWidth error={errors.email?.message} />
                                            ) : (
                                                <span className={styles.clientEmail}>{props.selectedPackage?.Email ?? '—'}</span>
                                            )}
                                        </div>
                                    )}
                                    {!verifyHideCountryItems(["us"]) && props.selectedPackage?.UserIdGl && (
                                        <div className={styles.clientIdRow}>
                                            <FaKey size={14} className={styles.clientIdIcon} />
                                            <span className={styles.clientIdLabel}>{translate("global.client")} ID</span>
                                            <span className={styles.clientIdValue}>{props.selectedPackage.UserIdGl}</span>
                                        </div>
                                    )}
                                </div>
                                {verifyHideCountryItems(["pa"]) && props.selectedPackage?.IdCliente && (
                                    <Link to={`/dashboard/clients/details/${props.selectedPackage.IdCliente}`} className={styles.viewClientBtn}>
                                        <FaEnvelope size={14} />
                                        <span>{translate("dashboard.clients.actions.viewDetails") || "View client"}</span>
                                    </Link>
                                )}
                            </div>
                        </ContentCard>

                        {/* Locker: título arriba, valor debajo; icono plataforma */}
                        <ContentCard title={<div className={styles.cardTitle}><PiLockersFill size={20} /><span>{translate("global.locker")}</span></div>} padding="md" className={`${styles.infoCard} ${styles.compactCard}`}>
                            <div className={styles.compactCardBody}>
                                <div className={styles.locationBlock}>
                                    <span className={styles.locationLabel}>{translate("global.locker")}</span>
                                    {props.optionSelected !== "ChangePlatform" ? (
                                        <span className={styles.locationValue}>{props.selectedPackage?.Plataforma ?? '—'}</span>
                                    ) : (
                                        <div style={{ width: '100%', minWidth: 0 }}>
                                            <PlatformList errors={errors} register={register} nameShow={props.selectedPackage?.Plataforma} idShow={props.selectedPackage?.IdPlataforma} readOnly={false} />
                                        </div>
                                    )}
                                </div>
                                {canReadPickupCode && (
                                    <div className={styles.locationBlock}>
                                        <span className={styles.locationLabel}>{translate("dashboard.packages.details.pickUpCode") || translate("global.key") || "Pick up code"}</span>
                                        <div className={styles.locationValueWithAction}>
                                            <input type={showPin ? "text" : "password"} value={props?.selectedPackage?.Clave || ""} readOnly className={styles.inputLikeInput} style={{ flex: 1, maxWidth: 200 }} id="inputClave" />
                                            <button type="button" onClick={handleViewPin} className={styles.copyButton} style={{ padding: '0.5rem 0.75rem' }} aria-label={showPin ? 'Ocultar' : 'Mostrar'}>
                                                {showPin ? <FaEyeSlash size={16} /> : (!isLoadingPin ? <FaEye size={16} /> : <Spinner type={1} size={15} />)}
                                            </button>
                                        </div>
                                    </div>
                                )}
                                {props.selectedPackage?.Identificacion && (
                                    <div className={styles.locationBlock}>
                                        <span className={styles.locationLabel}>{translate("global.door")}</span>
                                        <span className={styles.locationValue}>{props.selectedPackage?.Identificacion || '—'}</span>
                                    </div>
                                )}
                                <div className={styles.locationBlock}>
                                    <span className={styles.locationLabel}>{translate("global.dateExpiration")}</span>
                                    {props.optionSelected === "ChangeDateExpiration" ? (
                                        <input type="date" defaultValue={props.selectedPackage?.FechaExpiracion ? formatDatePicker(new Date(props.selectedPackage.FechaExpiracion)) : ""} name="dateExpiration" ref={register({ required: true })} className={styles.inputLikeInput} required />
                                    ) : (
                                        <span className={styles.locationValue}>{props.selectedPackage?.FechaExpiracion ? formatDatePicker(new Date(props.selectedPackage.FechaExpiracion), 2) : '—'}</span>
                                    )}
                                </div>
                                {((props.selectedPackage?.IdEstatus === 4 || props.selectedPackage?.IdEstatus === 6) && verifyHideCountryItems(["pa"]) && userRole >= 5) && (
                                    <div className={styles.locationBlock} style={{ borderBottom: 'none' }}>
                                        <span className={styles.locationLabel}>SYNC</span>
                                        <div className={styles.locationValueWithAction} role="button" tabIndex={0} onClick={() => { const ref = document.querySelector('#btn-sync'); if (ref) ref.click(); }} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); const ref = document.querySelector('#btn-sync'); if (ref) ref.click(); } }}>
                                            <BtnSync size="sm" id="btn-sync" mode="package" packageId={props.selectedPackage?.IdPaquete} reservationId={props.selectedPackage?.ReservationIdGl} />
                                            <span style={{ fontWeight: 600 }}>SYNC</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </ContentCard>
                    </div>
                </div>

                {
                    props.isOpenModalChangeClient &&
                    <div>
                        {renderModalChangeClient}
                    </div>
                }

                {(props.optionSelected === "ChangePlatform" || props.optionSelected === "ChangeClient" || props.optionSelected === "ChangeInfo" || props.optionSelected === "ChangeDateExpiration") &&
                    <div className={styles.headerActions} style={{ marginTop: '1rem', justifyContent: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
                        <Button variant="ghostOutline" type="button" onClick={cancelOption} className={styles.sectionEditButton}>{translate("global.cancel")}</Button>
                        <Button variant="primary" type="submit" className={styles.sectionEditButton}>{translate("global.register")}</Button>
                    </div>
                }
            </form>
        </>
    );
}


export default PackageInfo;
